export default __webpack_public_path__ + "static/media/delivery.9e7c1ddc.svg";